import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import ExpenseImg from "../../../assets/user/images/expense1.jpg";
import TrashImg from "../../../assets/user/images/trash.svg";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import { api } from "../../../utlis/staff/api.utlis";
import ApiService from "../../../core/services/ApiService";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import Loader from "../../../layouts/loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/staff/routes.utlis";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import toast from "react-hot-toast";
import { encode } from "base-64";
import { Modal, ModalBody } from "react-bootstrap";
import moment from "moment";

const List = () => {
  const navigate = useNavigate();
  const [list, setExpenseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState(new Date());
  const [deleteExpense, setDeleteExpense] = useState({
    status: false,
    id: null,
  });

  const getExpenseList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("expense listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setExpenseList(response.data.data.expenses);
    } else setExpenseList([]);
    setLoading(false);
  };

  const deleteCareExpense = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.expenseDelete + `${deleteExpense.id}`
    );
    setDeleteExpense(false);
    if (response.data.status) {
      toast.success(response.data.message);
      getExpenseList(api.expenseListing);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    let month = "";
    let year = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "") {
      month = moment(date).format("MM");
      year = moment(date).format("yyyy");
    } else {
      month = "";
      year = "";
    }
    getExpenseList(
      api.expenseListing + `?search=${name}&month=${month}&year=${year}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const currentDate = new Date();
    setMonth(currentDate);
    const fakeEvent = { persist: () => {}, target: { name: "date" } };
    handleFilter(fakeEvent, currentDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container" style={{ minHeight: "400px" }}>
        <div className="care-expenses-section">
          <div className="expenses-title-header">
            <h2 className="heading-title">Expense Log</h2>
            <div className="search-filter wd50">
              <div className="row g-2">
                <div className="col-md-4">
                  <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat="MM/yyyy"
                      selected={month}
                      onChange={(date, e) => {
                        setMonth(date);
                        handleFilter(e, date);
                      }}
                      className="form-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="Select Month/Year"
                      showMonthYearPicker
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="search-form-group">
                      <input
                        type="text"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                        className="form-control"
                        placeholder="Search Title"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <Link
                    className="btn-gr w-100"
                    to=""
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {list?.length !== 0 ? (
              list?.map((ele, indx) => {
                return (
                  <div className="col-md-6" key={indx}>
                    <div className="log-expenses-card">
                      <div className="log-expenses-image">
                        {ele.image === null ||
                        ele.image === "" ||
                        ele.image === undefined ? (
                          <img src={NoImage} alt="" className="me-3" />
                        ) : (
                          <img src={ele.image} alt="" className="me-3" />
                        )}
                        <img src={ExpenseImg} />
                      </div>
                      <div className="log-expenses-content">
                        <div className="log-expenses-head">
                          <div className="log-expenses-tag-list">
                            <div className="tags-item1">
                              {ele.is_recurring == 1
                                ? "Recurring"
                                : "Non Recurring"}
                            </div>
                            <div className="tags-item-sub1">
                              {ele.expense_date ?? "NA"}
                            </div>
                          </div>
                          <div className="log-expenses-action">
                            <Link
                              className="edit-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.expenseEdit, {
                                  state: {
                                    id: encode(ele.id),
                                  },
                                });
                              }}
                            >
                              <img src={Edit2} />
                            </Link>
                            <Link
                              className="delete-btn"
                              to=""
                              onClick={() =>
                                setDeleteExpense({ status: true, id: ele.id })
                              }
                            >
                              <img src={TrashImg} />
                            </Link>
                          </div>
                        </div>
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <div className="log-expenses-price-info">
                          <div className="log-expenses-paycard text-capitalize">
                            {ele.payment_type ?? "NA"}
                          </div>
                          {ele.is_recurring == 1 ? (
                            <div className="log-expenses-price">
                              ${ele.amount ?? 0}/
                              {ele.type == "M" ? "Month" : "Year"}
                            </div>
                          ) : (
                            <div className="log-expenses-price">
                              ${ele.amount ?? 0}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={deleteExpense.status}
        onHide={() => {
          setDeleteExpense({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Care Expense</h5>
                <p className="text-center">
                  Deleting this care expense cannot be undone. Are you sure you
                  want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteExpense({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteCareExpense()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default List;
